module.exports = __webpack_public_path__ + "c3331b98a0c63710dfa25ce8642aac29.svg";